import { useEffect, useState } from 'react'
import { FaCheck } from 'react-icons/fa'

import {
  AdminCard,
  Field,
  Input,
  Textarea,
  Toggle,
  BtnPrimary
} from './AdminUI'

import {
  getHero,
  saveHero
} from '../../../api/portfolioApi'
import {
  useAdmin
} from '../../../context/AdminContext'



export default function HeroEditor({ onSaved }) {


  const {
  refreshPortfolio
} = useAdmin()

  // ================= STATE =================

  const [loading, setLoading] = useState(false)

  const [error, setError] = useState('')

  const [local, setLocal] = useState({
    name: '',
    role: '',
    tagline: '',
    availableForWork: false
  })

  // ================= LOAD HERO =================

  useEffect(() => {
    loadHeroData()
  }, [])

  const loadHeroData = async () => {
    try {

      setLoading(true)

      const data = await getHero()

      if (data) {
        setLocal({
          name: data.name || '',
          role: data.role || '',
          tagline: data.tagline || '',
          availableForWork: data.availableForWork || false
        })
      }

    } catch (err) {

      console.error(err)
      setError('Failed to load hero section')

    } finally {

      setLoading(false)

    }
  }

  // ================= HANDLE INPUT =================

  const set = (key, value) => {
    setLocal(prev => ({
      ...prev,
      [key]: value
    }))
  }

  // ================= SAVE HERO =================

  const handleSave = async () => {

    try {

      setLoading(true)
      setError('')

      await saveHero(local)

      await refreshPortfolio()
      onSaved('Hero section updated!')

    } catch (err) {

      console.error(err)

      setError('Failed to save hero section')

    } finally {

      setLoading(false)

    }
  }

  // ================= UI =================

  return (
    <AdminCard
      title="Hero Section"
      subtitle="Name, role, tagline, availability"
    >

      {/* Error */}
      {error && (
        <div className="mb-4 rounded-xl border border-red-500/20 bg-red-500/10 px-4 py-3 text-sm text-red-400">
          {error}
        </div>
      )}

      <div className="grid sm:grid-cols-2 gap-4">

        <Field label="Full Name">
          <Input
            value={local.name}
            onChange={(e) => set('name', e.target.value)}
            placeholder="Your name"
            maxLength={60}
          />
        </Field>

        <Field label="Role / Title">
          <Input
            value={local.role}
            onChange={(e) => set('role', e.target.value)}
            placeholder="e.g. Software Engineer"
            maxLength={60}
          />
        </Field>

      </div>

      <Field label="Tagline / Bio (short)">
        <Textarea
          value={local.tagline}
          onChange={(e) => set('tagline', e.target.value)}
          placeholder="Short intro shown in hero..."
          rows={3}
        />
      </Field>

      <div className="mb-4">
        <Toggle
          checked={local.availableForWork}
          onChange={(value) => set('availableForWork', value)}
          label="Show 'Available for opportunities' badge"
        />
      </div>

      <BtnPrimary
        onClick={handleSave}
        disabled={loading}
      >
        <FaCheck size={11} />

        {loading ? 'Saving...' : 'Save Hero'}
      </BtnPrimary>

    </AdminCard>
  )
}